import { getCompoundEntityRef } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  Direction,
  EntityRelationsGraph,
} from '@backstage/plugin-catalog-graph';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  // Own tab, so the graph gets real estate rather than a letterbox. Sized off
  // the viewport so it fills whatever screen it lands on.
  panel: {
    border: '1px solid var(--ar-border-soft)',
    borderRadius: 8,
    background: 'var(--ar-surface)',
    padding: 8,
    // Without an explicit width the graph has no intrinsic size and the whole
    // container collapses (the SVG measures its parent).
    width: '100%',
    boxSizing: 'border-box',
    height: 'calc(100vh - 260px)',
    minHeight: 420,
    overflow: 'hidden',
  },
  graph: { height: '100%', width: '100%' },
});

/**
 * Dependency graph tab.
 *
 * The overview lists relationships as text because lists answer "what is this
 * connected to" at a glance. This is the other job: following the chain, which
 * needs space and interaction, so it gets its own tab.
 */
export const EntityGraph = () => {
  const classes = useStyles();
  const { entity } = useEntity();

  return (
    <div className={classes.panel}>
      <EntityRelationsGraph
        rootEntityNames={getCompoundEntityRef(entity)}
        maxDepth={3}
        mergeRelations
        direction={Direction.LEFT_RIGHT}
        curve="curveMonotoneX"
        zoom="enable-on-click"
        showArrowHeads
        allowFullscreen
        className={classes.graph}
      />
    </div>
  );
};
